/*
 * Copyright (c) 2025 - 2026. Bluemate B.V.
 */
import './style/iconWithLabel.scss';

import {AwesomeIcon} from '@dvrd/dvr-controls';

import {IconName, IconPrefix} from '@fortawesome/fontawesome-svg-core';

import React from 'react';

import classNames from 'classnames';

interface Props extends React.ComponentProps<any> {
    label: string;
    name: IconName;
    labelClassName?: string;
    iconClassName?: string;
    prefix?: IconPrefix;
}

export default function IconWithLabel(props: Props) {
    const {label, labelClassName, className, iconClassName} = props;
    // Recompute every render — NOT memoized. A `useMemo(…, [])` here froze the
    // forwarded props (including `onClick`) at mount, so when a list reused this
    // instance for a different item (index keys + a deleted sibling) the icon
    // kept firing the previous item's handler. That was the "second delete of
    // the same type does nothing until you refresh" bug: the reused delete
    // button still targeted the already-deleted notification.
    const reactProps = {...props};
    delete reactProps['labelClassName'];
    delete reactProps['iconClassName'];
    return (
        <div className={classNames('icon-with-label', className)}>
            <AwesomeIcon {...reactProps} className={iconClassName} />
            <label className={classNames('icon-title', labelClassName)}>{label}</label>
        </div>
    );
}
